import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const HOUR = 3600000;

export const waitedMs = (iso, now = Date.now()) => Math.max(0, now - new Date(iso).getTime());

const fmtWait = (ms) => {
  const m = Math.floor(ms / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ${m % 60}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
};

const tone = (ms) => {
  if (ms < 4 * HOUR) return "bg-[#2D6A4F]/12 text-[#2D6A4F] border-[#2D6A4F]/25";
  if (ms < 24 * HOUR) return "bg-[#E9C46A]/25 text-[#8A5A00] border-[#E9C46A]/60";
  return "bg-[#E63946]/10 text-[#C1121F] border-[#E63946]/30";
};

const level = (ms) => (ms < 4 * HOUR ? "green" : ms < 24 * HOUR ? "amber" : "red");

export const LeadWaitTimer = ({ at, id }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(t);
  }, []);
  if (!at) return null;
  const ms = waitedMs(at, now);
  return (
    <span data-testid={`lead-wait-timer-${id}`} data-level={level(ms)} title={`Customer requested ${new Date(at).toLocaleString()}`}
      className={`inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-full border tabular-nums transition-colors ${tone(ms)}`}>
      <Timer className="w-2.5 h-2.5" /> {ms < 60000 ? "Just arrived" : `Waiting ${fmtWait(ms)}`}
    </span>
  );
};
